import { LambdaClient, InvokeCommand } from "@aws-sdk/client-lambda"
import { fetchAuthSession } from "aws-amplify/auth";

// utilities
import { resolveLambdaArn } from "../../utilities";

// env
const {
  REACT_APP_REGION,
  REACT_APP_ADMIN_APPROVE_NEW_PARTNER_FUNCTION_NAME,
} = process.env;

const invokeLambda = async (awsCredentials, { userId, adminUserId }) => {
  const lambda = new LambdaClient({
    region: REACT_APP_REGION,
    credentials: awsCredentials,
  });

  // build command
  const command = new InvokeCommand({
    FunctionName: resolveLambdaArn('account', REACT_APP_ADMIN_APPROVE_NEW_PARTNER_FUNCTION_NAME),
    Payload: JSON.stringify({
      user_id: userId,
      admin_user_id: adminUserId,
    }),
    InvocationType: 'RequestResponse',
  });
  await lambda.send(command);
}

const handler = async ({ user_id: partner_user_id }, { getState, rejectWithValue }) => {
  try {
    // get credentials
    const { user } = getState();
    const { user_id: admin_user_id } = user;
    const { credentials } = await fetchAuthSession();

    await invokeLambda(credentials, { 
      userId: partner_user_id,
      adminUserId: admin_user_id,
    });
    console.log('services.partners.postApproveNewPartner@handler', 'Completed invoking lambda');
    return partner_user_id;

  } catch (error) {
    console.error('services.partners.postApproveNewPartner@handler', error);
    return rejectWithValue(error);
  }
}

const pending = (state, action) => {
  return {
    ...state,
  };
}

const fulfilled = (state, action) => {
  return {
    ...state,
    lists: state.lists.filter(item => item.account_id !== action.payload),
  };
}

const rejected = (state, action) => {
  return {
    ...state,
  };
}

export default {
  handler,
  pending,
  fulfilled,
  rejected
}